import React, { useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import HtmlEditor from '../strategyForm/htmlEditor';

export default function FormDialog(props) {
    const {strategie, open, setOpen, onConfirm, title, description } = props;

    let strategieInfos = strategie;

    const [contentValue, setContentValue] = useState(strategie?.contenu);
    const [content_enValue, setContent_enValue] = useState(strategie?.contenu_en);

    const onContentChange = (value) => setContentValue(value);

    const onContent_enChange = (value) => setContent_enValue(value);

  return (
    <div>
      <Dialog open={open}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
           {description}
          </DialogContentText>
          <div>
            <HtmlEditor strategieTemp={contentValue} onContentChange={onContentChange} />
          </div>
        </DialogContent>
        <DialogContent>
          <DialogContentText>
           {description}
          </DialogContentText>
          <div>
            <HtmlEditor strategieTemp={content_enValue} onContentChange={onContent_enChange} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            strategieInfos.contenu = contentValue;
            strategieInfos.contenu_en = content_enValue;
            onConfirm(strategieInfos);
            setOpen(false);
        }}>Confirm</Button>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>

      
    </div>
  );
}